import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

const VARIABLES = ['a', 'b', 'c', 'x', 'y', 'z']

const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 2,
    maxTerms: 8,
    operators: ['+'],
    maxHistoryLength: 7,
  },
  2: {
    minTerms: 4,
    maxTerms: 8,
    operators: ['-'],
    maxHistoryLength: 7,
  },
  3: {
    minTerms: 4,
    maxTerms: 7,
    operators: ['+', '-'],
    maxHistoryLength: 10,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  operators: Array<'+' | '-'>
  maxHistoryLength: number
}

export interface CoefficientInputActivityDataModel {
  variable: string
  operators: string[]
  answer: number
  maxHistoryLength: number
}

export function generateCoefficientInputActivityData(difficultyLevel: number): CoefficientInputActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const variable = VARIABLES[getRandomInt(0, VARIABLES.length - 1)]
  const totalTerms = getRandomInt(range.minTerms, range.maxTerms)
  const operators = []
  let answer = 0
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms; i++) {
    if (range.operators.length > 1) {
      operators[i] = range.operators[getRandomInt(0, range.operators.length - 1)]
    } else {
      operators[i] = range.operators[0]
    }
    if (operators[i] === '-') {
      answer--
    } else {
      answer++
    }
  }
  if (answer === 0) {
    operators[operators.length] = '-'
    answer--
  } else if (answer === 1) {
    operators[operators.length] = '+'
    answer++
  }
  return { variable, operators, answer, maxHistoryLength: range.maxHistoryLength }
}

export function checkCoefficientInputAnswer(answer: number, userAnswer: string): boolean {
  if (parseFloat(userAnswer) === parseFloat(answer.toString()) || (answer === -1 && userAnswer === '-')) {
    return true
  }
  return false
}
